const REVIEWER_COLORS = ["--main", "--green", "--orange", "--purple", "--pink", "--yellow"];

export default function reviewerColor(key = "") {
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
        hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
    }
    return `var(${REVIEWER_COLORS[hash % REVIEWER_COLORS.length]})`;
}
